import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <div className="hero-container">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1>Building Secure & Engaging<br /><span>Digital Experiences</span></h1>
        <p>Crafting resilient web solutions with a focus on code integrity and cybersecurity expertise.</p>
      </div>
    </div>
  );
}

export default Hero;